// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileChartBar(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileChartBar" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5ZM14 10H12.5V18H14V10ZM10 13H11.5V18H10V13ZM9 14.5H7.5V18H9V14.5ZM15 12H16.5V18H15V12Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileChartBar.js.map